module.exports = __webpack_public_path__ + "static/media/buy_pay_invoice_3.f6b4be5a.jpg";